import type { ComponentProps } from 'react';
import { usePermission } from '../../../lib/usePermission';
import { PERMISSIONS } from '../../../lib/permissions';
import type { SttForm } from '../../../sporttia/SttForm';

type SttFormElements = NonNullable<ComponentProps<typeof SttForm>['elements']>;

/**
 * Si el operador puede cambiar la configuración del centro
 * (`configuration.modify`). Sin él, las pantallas de configuración se ven en
 * sólo lectura. Con los roles apagados siempre es `true`.
 */
export function useCanModifyConfiguration(): boolean {
    const { can } = usePermission();
    return can(PERMISSIONS.CONFIGURATION.MODIFY);
}

/**
 * Desactiva todos los campos de un `SttForm` cuando la configuración es de
 * sólo lectura, sin tocar los que ya estaban desactivados.
 */
export function lockFormElements(
    elements: SttFormElements,
    readOnly: boolean,
): SttFormElements {
    if (!readOnly) return elements;
    return elements.map((element) => ({ ...element, disabled: true }));
}
